import { Input } from "components/common/Input/Input";
import { Translate } from "components/common/Translate/Translate";
import { ChangeEvent } from "react";
import { useLeft } from "./useLeft";

export interface ITopProps {
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Left = ({ handleChange }: ITopProps) => {
    const { left } = useLeft();

    return (
        <div className="">
            <div className="capitalize mb-4" data-testid="left-input-label">
                <Translate keyName="position" /> (X)
            </div>
            <Input
                className="w-full"
                type="number"
                min={0}
                value={Math.round(left)}
                onChange={handleChange}
                data-testid="left-input"
            />
        </div>
    );
};
